import { render, staticRenderFns } from "./ac3.vue?vue&type=template&id=3804d4b8&scoped=true&"
import script from "./ac3.vue?vue&type=script&lang=js&"
export * from "./ac3.vue?vue&type=script&lang=js&"
import style0 from "./ac3.vue?vue&type=style&index=0&id=3804d4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804d4b8",
  null
  
)

export default component.exports